// extracted by mini-css-extract-plugin
export var ohohhoney = "j_fn";